export default __webpack_public_path__ + "static/media/ecofootprint.710a0125.png";